import { Code, Modal, Text } from '@mantine/core';
import { DataTableColumn } from 'mantine-datatable';
import React from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SimpleTable } from 'src/common/components/table/SimpleTable';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import CompanyWrapper from 'src/company/templates/components/CompanyWrapper';
import { Client } from 'src/admin/users/types';

export default function CompanyClientsPage() {
  return <CompanyWrapper contentComponent={CompanyCompanyClientsPageContent} />;
}

function CompanyCompanyClientsPageContent({ company }: { company: Company }) {
  const [selectedClient, setSelectedClient] = React.useState<Client | null>(null);

  const columns: DataTableColumn<Client>[] = [
    {
      accessor: 'lastName',
      title: 'Last name',
      sortable: true,
      render: record => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.lastName}
        </Text>
      ),
    },
    {
      accessor: 'firstName',
      title: 'First name',
      sortable: true,
      render: record => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.firstName}
        </Text>
      ),
    },
    {
      accessor: 'emailAddress',
      title: 'Email address',
      sortable: true,
      render: record => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.emailAddress}
        </Text>
      ),
    },
    {
      accessor: 'id',
      title: 'Client ID',
      sortable: true,
      render: record => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.id}
        </Text>
      ),
    },
  ];

  return (
    <>
      <Modal
        opened={!!selectedClient}
        onClose={() => setSelectedClient(null)}
        title="Client details"
        size="xxl"
      >
        <Code block>
          {JSON.stringify(
            selectedClient
              ? { ...selectedClient, personalDetails: 'REDACTED', dependants: 'REDACTED' }
              : null,
            null,
            2,
          )}
        </Code>
      </Modal>

      <SimpleTable<Client>
        resource={`admin/companies/${company.id}/clients`}
        columns={columns}
        title="Clients"
        showCount
        enableSearch
        pageSize={10}
        mode="client"
        onRowClick={setSelectedClient}
      />
    </>
  );
}
